import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {
    filterOutEmptySelectedAmenities
} from "@CheckOrder/features/amenities/functions/filterOutEmptySelectedAmenities";
import isEqual from "lodash/isEqual";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {Dispatch, SetStateAction} from "react";
import useUpdateAmenitiesQuery from "@CheckOrder/features/amenities/hooks/useUpdateAmenitiesQuery";

/**
 * Handles closing and final updating of amenities in amenity modal
 */
export default function useUpdateAmenitiesAndCloseSelection(
    closeDisplay: () => void,
    singleSelectedAmenities: Record<string, CountAmenitySelectedType>,
    returnSelectedAmenities: Record<string, CountAmenitySelectedType>,
    setSingleSelectedAmenities: Dispatch<SetStateAction<Record<string, CountAmenitySelectedType>>>,
    setReturnSelectedAmenities: Dispatch<SetStateAction<Record<string, CountAmenitySelectedType>>>
) {
    const {
        singleSelectedAmenities: previouslySelectedSingleAmenities,
        returnSelectedAmenities: previouslySelectedReturnAmenities,
    } = useAppSelector((state) => (state?.checkOrder?.ticket))

    const {updateAmenities, response} = useUpdateAmenitiesQuery()

    /**
     * Kill every user change and reset to previous
     */
    const closeWithoutUpdating = () => {
        setSingleSelectedAmenities(previouslySelectedSingleAmenities)
        setReturnSelectedAmenities(previouslySelectedReturnAmenities)

        closeDisplay()
    }

    /**
     * Apply users changes
     */
    const closeAndUpdate = async () => {
        closeDisplay()
        // don't start any updates if no changes were made
        if (
            isEqual(previouslySelectedSingleAmenities, singleSelectedAmenities)
            && isEqual(previouslySelectedReturnAmenities, returnSelectedAmenities)
        ) {
            return;
        }

        await updateAmenities(
            filterOutEmptySelectedAmenities(singleSelectedAmenities),
            filterOutEmptySelectedAmenities(returnSelectedAmenities)
        )
    }

    return {
        closeAndUpdate,
        closeWithoutUpdating,
        response,
    }
}